import React from 'react';
import { ILookupDetailList } from 'models/common-models';
import StandardResponse from 'models/standard-response';
import CommonConfigService from 'services/common/common-service';
import { handleErrorMessage } from './helper';

const commonConfigService = new CommonConfigService();

type SetState<T> = React.Dispatch<React.SetStateAction<T>>;
type FilterState = {
    sortOrder: string;
    sortColumn: string;
};

export function commonHandleChange<T>(setState: SetState<T>) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevForm) => ({
            ...prevForm,
            [event.target.name]: event.target.value,
        }));
    };
}

export function commonHandleDropdownChange<T>(setState: SetState<T>) {
    return (name: string, option) => {
        setState((prevForm) => ({
            ...prevForm,
            [name]: option,
        }));
    };
}

export function commonSearch<T>(setState: SetState<T>) {
    return () => {
        setState((prevState) => ({
            ...prevState,
            offset: 0,
            currentPage: 1,
        }));
    };
}

export function commonHandleSorting<T extends FilterState>(columnName: string, filterState: T, setState: SetState<T>) {
    let sortOrder = filterState.sortOrder;
    if (filterState.sortColumn === columnName) {
        sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
    } else {
        sortOrder = 'asc';
    }
    setState((prevState) => ({
        ...prevState,
        sortOrder: sortOrder,
        sortColumn: columnName,
    }));
}

export function commonHandleReset<SearchType, FilterType>(
    setSearch: SetState<SearchType>,
    defaultSearch: SearchType,
    setState: SetState<FilterType>,
) {
    setSearch(defaultSearch);
    setState((prevState) => ({
        ...prevState,
        offset: 0,
        currentPage: 1,
    }));
}

export function commonHandlePageChange<T>(currentPage: number, rowsPerPage: number, setState: SetState<T>) {
    const offset = (currentPage - 1) * rowsPerPage;
    setState((prevState) => ({
        ...prevState,
        currentPage: currentPage,
        rowsPerPage: rowsPerPage,
        offset: offset,
    }));
}

export const getLookupDetails = async (code: string[]) => {
    let lookupList: Array<ILookupDetailList> = [];
    const filterInput = {
        code: code,
    };
    await commonConfigService
        .getLookupDetailList(filterInput)
        .then(async (res: StandardResponse<Array<ILookupDetailList>>) => {
            if (Array.isArray(res.Data)) {
                lookupList = res.Data;
            }
        })
        .catch((m) => {
            handleErrorMessage(m);
        })
        .finally();
    return lookupList;
};

export const getConfigDetails = async (code: string) => {
    let config = '';
    const filterInput = {
        code: code,
    };
    await commonConfigService
        .getConfiguration(filterInput)
        .then(async (res: any) => {
            let data = res.data;
            config = data.filter((value) => {
                return value.reference_code === code;
            })[0].value;
        })
        .catch((m) => {
            handleErrorMessage(m);
        })
        .finally();
    return config;
};
